
import { Page, Text, View, Document, StyleSheet, Font, Image } from '@react-pdf/renderer';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom/cjs/react-router-dom';
import UserService from '../../controllers/UserService';
import { pdf } from '@react-pdf/renderer';
import AuthService from '../../controllers/AuthService';
Font.register('/font/Sarabun-Regular.ttf', { family: 'SarabunRegular' });
Font.register('/font/Sarabun-Bold.ttf', { family: 'SarabunBold' }); 
Font.registerHyphenationCallback(word => {
  return word.split('');
});

const styles = StyleSheet.create({

    page: {
        paddingBottom: 30
    },
    footer: {
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        padding: 10,
        display: 'flex',
        flexDirection: 'row',
    },

    footerTextR: {
        textAlign: 'right',
        fontSize: 10,
        fontFamily: 'SarabunRegular',
        lineHeight: 1.5,
        color: '#828282',
    },

    footerTextL: {
        textAlign: 'left',
        fontSize: 10,
        fontFamily: 'SarabunRegular',
        lineHeight: 1.5,
        color: '#828282',
    },
    header: {
        borderBottomWidth: 1,
        borderBottomColor: '#C4C4C4',
        color: '#000000',
        margin: 30,
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 10,
    },
    headerLeft: {
        textAlign: 'left',
        flex: 1,
        alignSelf: 'center',
        display: 'flex',
        flexDirection: 'row',
    },
    headerRight: {
        textAlign: 'right',
        flex: 1
    },
    HLB: {
        fontSize: 14,
        fontWeight: 900,
        lineHeight: 1.5,
        color: '#000000',
        fontFamily: 'SarabunBold',
    },
    HLR: {
        fontSize: 10,
        lineHeight: 1.5,
        color: '#000000',
        fontFamily: 'SarabunRegular',
    },
    image: {
        width: "100%",
    },
    rtIcon: {
        width: "90%",
        paddingLeft: 5
    },
    logo: {
        paddingRight: 5,
        width: "15%",
    },
    THL: {
        width: "85%",
    },
    header100: {
        borderBottomWidth: 1,
        borderBottomColor: '#C4C4C4',
        color: '#000000',
        margin: 30,
        marginBottom: 10,
        display: 'flex',
        flexDirection: 'row',
        paddingBottom: 10,
    },
    logo1: {
        paddingRight: 5,
        width: "7%",
    },
    THL1: {
        width: "60%",
    },
    THL2: {
        textAlign: 'right',
        width: "33%",
    },
    tableRowWhite: {
        padding: 10,
        display: 'block',
        flexDirection: 'row',
    },
    divRow: {
        color: '#000000',
        padding: 30,
        paddingBottom: 5,
        paddingTop: 0,
        display: 'flex',
        flexDirection: 'row',
        // overflowWrap: 'anywhere',
        // whiteSpace: 'break-spaces',
    },
    textBlue: {
        fontSize: 14,
        color: '#3765D1',
        lineHeight: 1.5,
        fontFamily: 'SarabunRegular',

    },
    boxLeft: {
        textAlign: 'left',
        flex: 1,
        alignSelf: 'left',
        display: 'flex',
        flexDirection: 'row',
    },
    boxRight: {
        textAlign: 'right',
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'right',
    },
    icon1: {
        marginLeft: 100,
        paddingRight: 0,
        width: "10%",
    },
    titleCenter: {
        textAlign: 'center',
        fontSize: 16,
        fontFamily: 'SarabunBold',
        paddingBottom: 10,
        paddingTop: 10,
        lineHeight: 1.5,
    },
    width100NormalText: {
        color: '#000000',
        fontSize: 14,
        fontFamily: 'SarabunRegular',
        width: "100%",
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        textAlign: 'center',
        overflowWrap: 'anywhere',
        whiteSpace: 'break-spaces',
    },
    width100NormalTextTitle: {
        color: '#000000',
        fontSize: 16,
        fontFamily: 'SarabunBold',
        width: "100%",
        lineHeight: 1.5,
        whiteSpace: 'nowrap',
        textAlign: 'center',
        overflowWrap: 'anywhere',
        whiteSpace: 'break-spaces',
        color: '#3765D1',
    },
    width33: {
        width: "33.33%",
    },
    width100: {
        width: "100%"
    },
    image1: {
        paddingTop: 10,
        paddingBottom: 10,
        textAlign: 'center'
    },
    image3: {
        paddingTop: 10,
        paddingBottom: 10,
        paddingHorizontal: 50,
        textAlign: 'center'
    },
    rowSpaceBetweenWithPadding: {
        flexDirection: 'row',
        justifyContent: 'space-between', // This will space out the content between left and right
        marginBottom: 10,
        padding: 30
    },
    rowSpaceBetween: {
        flexDirection: 'row',
        justifyContent: 'space-between',

        marginBottom: 10
    },
    leftStrengthColumn: {
        width: '50%',  // Makes sure the left column takes up almost half the page
        textAlign: 'left',
        paddingRight: 10,
        borderRightColor: '#C4C4C4',
        borderRightWidth: 1
    },
    rightStrengthColumn: {
        width: '48%',  // Same as above for the right column
        textAlign: 'left',
    },
    leftStrengthContentColumn: {
        width: '80%',  // Makes sure the left column takes up almost half the page
        textAlign: 'left',
    },
    rightStrengthContentColumn: {
        width: '20%',
        borderLeft: '4px solid #000',
        paddingLeft: 1,
        textAlign: 'right',
    },
    strengthListText: {
        fontSize: 12,
        color: '#000',
        lineHeight: 1.5,
        fontFamily: 'SarabunRegular'
    },
    answerBox: {
        padding: 10,
        borderWidth: 1,
        borderColor: '#828282',
        marginHorizontal: 30,
        marginVertical: 10,
        borderRadius: 12,
        flexDirection: 'column', // เปลี่ยนจาก 'row' เป็น 'column'
        flexWrap: 'wrap',
        overflow: 'hidden',
        width: 'auto',
    },
    normalText: {
        color: '#000000',
        fontSize: 14,
        fontFamily: 'SarabunRegular',
        lineHeight: 1.5,
        width: '100%',
        maxWidth: '100%',
        flexWrap: 'wrap',
    },
    subTitleLeft: {
        fontSize: 12,
        fontFamily: 'SarabunBold',
        lineHeight: 1.5,
        marginBottom: 5
    },
    strengthTitleLeft: {
        fontSize: 10,
        fontFamily: 'SarabunBold',
        lineHeight: 1.5,
        marginBottom: 5,
        wordWrap: 'break-word',
        width: '93%'
    },
    column32: {
        width: '32%'
    },
    strengthBox: {
        borderWidth: 1,
        borderColor: '#000',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        borderRadius: 6,
        paddingTop: 5,
        paddingBottom: 5
    },
    rowStrengthBoxBetweenWithPadding: {
        flexDirection: 'row',
        justifyContent: 'space-between', // This will space out the content between left and right
        paddingHorizontal: 30,
        paddingVertical: 10
    },
    strengthImage: {
        width: '33%',
        height: 'auto',
        marginRight: 1,
        marginVertical: 3
    },
    textContainer: {
        width: '70%', // Text takes up the remaining 70% of the box width
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
});


const saveBlob = (blob, filename) => {
    var a = document.createElement("a");
    document.body.appendChild(a);
    a.style.display = "none";
    let url = window.URL.createObjectURL(blob);
    a.href = url;
    a.download = filename;
    a.click();
    window.URL.revokeObjectURL(url);
};


const savePdf = async (document, filename) => {
    saveBlob(await pdf(document).toBlob(), filename);
};




const PdfStudentEvaluateTeacherReport = () => {

    let { roomId, teacherId } = useParams();
    const [headerText, setHeaderText] = useState('กิจกรรม Friendship ');
    const [userFullName, setUserFullName] = useState(AuthService.getUserFullName());
    if (!teacherId) { teacherId = AuthService.getCurrentUserId(); }
    let strengths = null
    let school = null;
    let logo = UserService.getLogoUrl();
    let dateString = '';
    let student = '';
    let apiFilter = {};
    let renderData = {};
    let teacher = '';


    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    var dateTemp = new Date(yyyy + '-' + mm + '-' + dd);


    const generateDate = (dateTime) => {
        var months_th = ["มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม",];
        var temp = dateTime.getFullYear() + 543;
        return dateTime.getDate() + ' ' + months_th[dateTime.getMonth()] + ' ' + temp;
    }

    dateString = generateDate(dateTemp);

    useEffect(() => {
        renderCenter(roomId);
    }, []);

    async function renderCenter(roomId) {
        try {
            let user = AuthService.getCurrentUser();

            // strengths
            const strengthsRes = await UserService.getStrengths();
            const strengthsData = strengthsRes.data.data;
            strengths = strengthsData;

            // Room Detail
            const roomDetail = await UserService.getRoomDetail(roomId);
            const roomDetailData = roomDetail.data.data;
            school = roomDetailData.domain.displayName;
            roomDetailData.teachers.forEach(item => {
                if (item.id === teacherId) {
                    teacher = item.fullName;
                    return;
                }
            });


            apiFilter = {
                "domain": user.domain.name,
                "roomId": roomId,
                "year": roomDetailData.year,
                "term": roomDetailData.term,
            };

            const friendshipRes = await UserService.getFriendShipList(teacherId, apiFilter);
            const friendshipData = friendshipRes.data.data
            renderData = computeAnswer(friendshipData[0]);


            var tempFileName = teacher + '_' + roomDetailData.term + '_' + roomDetailData.year + ".pdf";
            await savePdf(PdfFile(), tempFileName);
            setTimeout(() => { window.close(); }, 2000)
        } catch (error) {
            console.error('Error occurred:', error);
        }
    }

    const computeAnswer = (data) => {
        var allAnswer0 = [];
        var allStudentAnswer = 0;
        let doneStatus = false;
        var selfText = [];
        let newStrengthsSorted = [];
        let strengthThLang = [];
        for (const [index, aAnswer] of data.others.entries()) {
            if (aAnswer.user.roles[0].toLowerCase() !== 'teacher' && aAnswer.answerAt !== null) {
                if (teacherId !== aAnswer.user.id) {
                    //student Evaluate         
                    doneStatus = true;
                    if (allAnswer0[aAnswer.answers[0].values[0]]) {
                        allStudentAnswer++;
                        allAnswer0[aAnswer.answers[0].values[0]] += 1;
                    } else {
                        allStudentAnswer++;
                        allAnswer0[aAnswer.answers[0].values[0]] = 1;
                    }

                    if (allAnswer0[aAnswer.answers[1].values[0]]) {
                        allAnswer0[aAnswer.answers[1].values[0]] += 1;
                    } else {

                        allAnswer0[aAnswer.answers[1].values[0]] = 1;
                    }

                    if (allAnswer0[aAnswer.answers[2].values[0]]) {
                        allAnswer0[aAnswer.answers[2].values[0]] += 1;
                    } else {

                        allAnswer0[aAnswer.answers[2].values[0]] = 1;
                    }


                    selfText.push(aAnswer.answers[3].values[0]);

                }
            }
        }

        strengths.forEach(item => {
            newStrengthsSorted[item.id] = allAnswer0[item.id] ?? 0;
            if (item.id === "leadership") {
                strengthThLang[item.id] = "ความเป็นผู้นำ ";
            } else {
                strengthThLang[item.id] = item.name;
            }
        });

        newStrengthsSorted = Object.fromEntries(
            Object.entries(newStrengthsSorted).sort(([, a], [, b]) => b - a)
        );

        return {
            totalStudentAnswer: allStudentAnswer,
            comments: selfText,
            newStrengthsSorted: newStrengthsSorted,
            strengthThLang: strengthThLang
        };

    }


    const renderRows = (side = 'left', sData, strengthThLang) => {
        const rows = [];
        const key = Object.keys(sData);
        const startInd = side === 'left' ? 7 : 17;
        const endInd = side === 'left' ? 16 : 24;
        for (let i = startInd; i <= endInd; i += 1) {
            rows.push(
                <View style={styles.rowSpaceBetween} key={i}>
                    <View style={styles.leftStrengthContentColumn}>
                        <Text style={styles.strengthListText}>{i}. {strengthThLang[key[i - 1]]}</Text>
                    </View>
                    <View style={styles.rightStrengthContentColumn}>
                        <Text style={styles.strengthListText}>   {sData[key[i - 1]]}  คน</Text>
                    </View>
                </View>
            );
        }
        return rows;
    };

    const renderComments = (comments) => {
        const data = [];
        for (let i = 0; i < comments.length; i += 1) {
            const formatted = comments[i] + '      ';
            data.push(
                <View style={styles.answerBox} key={i}>
                    <Text style={styles.normalText}>{formatted}</Text>
                </View>
            );
        }
        return data;
    };

    const castTextForTopLevel = (text) => {
        if (text === "การรู้สึกขอบคุณสิ่งรอบตัว") return "การรู้สึกขอบคุณสิ่ง\nรอบตัว";
        if (text === "การชื่นชมความงามและความเป็นเลิศ") return "การชื่นชมความงาม\nและความเป็นเลิศ";
        if (text === "การให้อภัยและความมีเมตตา") return "การให้อภัยและความ\nมีเมตตา";
        if (text === "การรู้สึกขอบคุณสิ่งรอบตัว") return "การรู้สึกขอบคุณสิ่ง\nรอบตัว";
        return text;
    }

    const renderTopRows = (sData, strengthThLang) => {
        const rows = [];
        const key = Object.keys(sData);
        for (let i = 0; i < 6; i += 3) {
            rows.push(
                <View style={styles.rowStrengthBoxBetweenWithPadding} key={i}>
                    <View style={styles.column32}>
                        <View style={styles.strengthBox} wrap={false}>

                            <View style={styles.strengthImage}>
                                <Image src={`/images/strengths/rt-icon/${key[i]}.jpg`} style={styles.rtIcon} />
                            </View>

                            <View style={styles.textContainer}>
                                <Text style={styles.strengthTitleLeft}> {i + 1}. {castTextForTopLevel(strengthThLang[key[i]])}</Text>
                                <Text style={styles.strengthListText}> {sData[key[i]]} คน</Text>
                            </View>

                        </View>


                    </View>
                    {strengths[i + 1] && (
                        <View style={styles.column32}>

                            <View style={styles.strengthBox} wrap={false}>

                                <View style={styles.strengthImage}>
                                    <Image src={`/images/strengths/rt-icon/${key[i + 1]}.jpg`} style={styles.rtIcon} />
                                </View>

                                <View style={styles.textContainer}>
                                    <Text style={styles.strengthTitleLeft}> {i + 2}. {castTextForTopLevel(strengthThLang[key[i + 1]])}</Text>
                                    <Text style={styles.strengthListText}>  {sData[key[i + 1]]} คน</Text>
                                </View>

                            </View>



                        </View>
                    )}
                    {/* Right Column */}
                    {strengths[i + 2] && (
                        <View style={styles.column32}>
                            <View style={styles.strengthBox} wrap={false}>

                                <View style={styles.strengthImage}>
                                    <Image src={`/images/strengths/rt-icon/${key[i + 2]}.jpg`} style={styles.rtIcon} />
                                </View>

                                <View style={styles.textContainer}>
                                    <Text style={styles.strengthTitleLeft}>{i + 3}.  {castTextForTopLevel(strengthThLang[key[i + 2]])}</Text>
                                    <Text style={styles.strengthListText}>  {sData[key[i + 2]]} คน</Text>
                                </View>

                            </View>

                        </View>
                    )}
                </View>
            );
        }
        return rows;
    };

    const PdfFile = () => {
        return (
            <Document>
                <Page size="A4" style={styles.page} wrap>

                    <View style={styles.header100} fixed>
                        <View style={styles.logo1}>
                            <Image style={styles.image} src={logo} />
                        </View>
                        <View style={styles.THL1}>
                            <Text style={styles.HLB}>{school}</Text>
                            <Text style={styles.HLR}>วันที่ออกรายงาน : {dateString}</Text>
                        </View>
                        <View style={styles.THL2}>
                            <Text style={styles.HLB}>{headerText}</Text>
                            <Text style={styles.HLR}>ผู้ออกรายงาน : {userFullName}</Text>
                        </View>
                    </View>

                    <View style={styles.divRow} fixed>
                        <View style={styles.headerLeft}>
                            <Text style={styles.textBlue}>รายงานของ : {teacher}</Text>
                        </View>
                    </View>



                    <View >
                        <View style={styles.divRow}>
                            <Text style={styles.titleCenter}>Friendship - ผลประเมินจากมุมมองของนักเรียน</Text>
                        </View>
                    </View>

                    <View style={styles.divRow}>
                        <View style={styles.headerLeft}>
                            <Text style={styles.subTitleLeft}>จำนวนนักเรียนที่ประเมิน: {renderData.totalStudentAnswer ?? 0} คน</Text>
                        </View>
                    </View>

                    <View>
                        {renderData.newStrengthsSorted ? renderTopRows(renderData.newStrengthsSorted, renderData.strengthThLang) : null}
                    </View>
                    <View>
                        <View style={styles.rowSpaceBetweenWithPadding}>
                            <View style={styles.leftStrengthColumn}>
                                {renderData.newStrengthsSorted ? renderRows('left', renderData.newStrengthsSorted, renderData.strengthThLang) : null}


                            </View>
                            <View style={styles.rightStrengthColumn}>
                                {renderData.newStrengthsSorted ? renderRows('right', renderData.newStrengthsSorted, renderData.strengthThLang) : null}

                            </View>
                        </View>

                    </View>

                    <Text break />

                    <View >
                        <View wrap>
                            <View style={styles.divRow} breaks>
                                <Text style={styles.titleCenter}>ความคิดเห็นในมุมมองของนักเรียนที่มีต่อคุณครู</Text>
                            </View>

                            {renderData?.comments ? renderComments(renderData.comments) : null}

                        </View>
                    </View>




                    <View style={styles.footer} fixed>
                        <View style={styles.headerLeft}>
                            <Text style={styles.footerTextL} >ออกโดยบริษัท MINDSET MAKER CO., LTD.</Text>
                        </View>
                        <View style={styles.headerRight}>
                            <Text style={styles.footerTextR} render={({ pageNumber, totalPages }) => (
                                `หน้า : ${pageNumber}/${totalPages}`
                            )} fixed />
                        </View>
                    </View>
                </Page>

            </Document>);
    }
    return ''
}
export default PdfStudentEvaluateTeacherReport;